module.exports = __webpack_public_path__ + "static/img/xzicon02.png";